import { FormSteps, InitiateAuth } from '@pages/auth'
import React, { Dispatch, SetStateAction } from 'react'
import { DeepMap, FieldError, UseFormHandleSubmit } from 'react-hook-form'
import V1AuthFlow from './v1'
import V2AuthFlow from './v2'

export interface AuthFlowProps {
  displayAuthenticationRevisedLayout: boolean
  step: FormSteps
  verificationFormData: InitiateAuth
  onVerificationSubmit: (formData: any) => Promise<void>
  otpFailureMessage: string
  setOtpFailureMessage?: Dispatch<SetStateAction<string>>
  isLoading: boolean
  handleSubmit: UseFormHandleSubmit<any>
  onSubmitContact: (formData: InitiateAuth) => Promise<void>
  register: (field) => void
  errors: DeepMap<any, FieldError>
  isValid: boolean
}

export default function AuthFlow({
  displayAuthenticationRevisedLayout,
  step,
  verificationFormData,
  onVerificationSubmit,
  otpFailureMessage,
  setOtpFailureMessage,
  isLoading,
  handleSubmit,
  onSubmitContact,
  register,
  errors,
  isValid,
}: AuthFlowProps) {
  return displayAuthenticationRevisedLayout ? (
    <V2AuthFlow
      step={step}
      verificationFormData={verificationFormData}
      onVerificationSubmit={onVerificationSubmit}
      otpFailureMessage={otpFailureMessage}
      setOtpFailureMessage={setOtpFailureMessage}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      onSubmitContact={onSubmitContact}
      register={register}
      errors={errors}
      isValid={isValid}
    />
  ) : (
    <V1AuthFlow
      step={step}
      verificationFormData={verificationFormData}
      onVerificationSubmit={onVerificationSubmit}
      otpFailureMessage={otpFailureMessage}
      setOtpFailureMessage={setOtpFailureMessage}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      onSubmitContact={onSubmitContact}
      register={register}
      errors={errors}
      isValid={isValid}
    />
  )
}
